import { DiagnoseFormInfoDto } from '../generated';
import { Diagnosis } from '../model/Diagnosis';

export const parseDiagnosis = (data: DiagnoseFormInfoDto): Diagnosis => {
  return {
    name: data.name,
    subDiagnoses: data.subDiagnoses.map(parseDiagnosis)
  };
};
